import { render, staticRenderFns } from "./footerBtn.vue?vue&type=template&id=c7b42a46&scoped=true"
import script from "./footerBtn.vue?vue&type=script&lang=js"
export * from "./footerBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b42a46",
  null
  
)

export default component.exports